import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useSurveyStore } from "@stores/survey/survey";
import { useCurrentUserStore } from "@stores/currentUser";
import useMyFetch from "@stores/useMyFetch";

export const useFilterableCards = () => {
  const { token: surveyToken } = storeToRefs(useSurveyStore());
  const filterableCards = ref<unknown[]>([]);

  const fetchFilterableCards = async () => {
    if (filterableCards.value.length || !surveyToken.value) return;
    const { response, data } = await useMyFetch(
      `/surveys/${surveyToken.value}/cards?type=questions&with_questions=true${useCurrentUserStore().isAdmin ? "" : "&is_admin=false"}`,
    )
      .get()
      .json();
    if (response.value?.ok) filterableCards.value = data.value || [];
  };

  return { filterableCards, fetchFilterableCards };
};
